document.addEventListener("DOMContentLoaded", () => {
  window.addEventListener("load", () => {
      const arabic = document.querySelector(".nturl[data-gt-lang='ar']")
      const customWeglot = document.querySelectorAll(".custom-language-switch");
      console.log(customWeglot)
      const english = document.querySelector(".nturl[data-gt-lang='en']")
      console.log(english)
      console.log(arabic);

      customWeglot.forEach(item => {
        item.addEventListener("click", () => {
          if (english.classList.contains("gt-current")) {
            arabic.click();
            console.log("CLICKED ARABIC");
          } else if (arabic.classList.contains("gt-current")) {
            english.click();
            console.log("CLICKED ENGLISH");
          }
        });
      });
      setTimeout(() => {
        if(english.classList.contains("gt-current")){
          customWeglot[0].textContent = "العربية"
          customWeglot[1].textContent = "العربية"
        } else if(arabic.classList.contains("gt-current")){
          customWeglot[0].textContent = "English"
          customWeglot[1].textContent = "English"
        }
      }, 100);
  });
});